"use client";

import { usePylonContextSafe } from "@/app/providers/PylonProvider/PylonContext";
export function usePylon() {
  return usePylonContextSafe();
}